var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChemicalListing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_5331_12249)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5331_12249)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.916 13.918H19.416V19.418H13.916V13.918ZM13.916 21.2513H19.416V26.7513H13.916V21.2513ZM13.916 28.5846H19.416V34.0846H13.916V28.5846ZM21.2493 17.5846H34.0827V15.7513H21.2493V17.5846ZM34.0827 24.918H21.2493V23.0846H34.0827V24.918ZM21.2493 32.2513H34.0827V30.418H21.2493V32.2513Z",
    fill: "url(#paint1_linear_5331_12249)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5331_12249",
    x1: 0,
    y1: 0,
    x2: 48,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA5A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5331_12249",
    x1: 23.9993,
    y1: 13.918,
    x2: 23.9993,
    y2: 34.0846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5331_12249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemicalListing);
export default __webpack_public_path__ + "static/media/chemical-listing.8bef90bcf911901319ce86b400561658.svg";
export { ForwardRef as ReactComponent };